import moment from 'moment';
import { union } from 'lodash';

export const DEFAULT_B_SIZE = 8;
export const FILTERS_ACTIONS = {
  DATE: 'DATE',
  TEXT: 'TEXT',
  SUBJECT: 'SUBJECT',
  RESET: 'RESET',
};

export const datesForDisplay = (start, end) => {
  const mStart = moment(start);
  const mEnd = moment(end);
  if (!mStart.isValid() || !mEnd.isValid()) {
    return null;
  }
  const sameYear = mStart.isSame(mEnd, 'year');
  const sameMonth = mStart.isSame(mEnd, 'month');
  const sameDay = mStart.isSame(mEnd, 'day');
  const sameTime = mStart.isSame(mEnd, 'minute');

  return {
    sameYear,
    sameMonth,
    sameDay,
    sameTime,
    mStart,
    mEnd,
  };
};

export const getDefaultStartEndDate = (whichEvents) => {
  let d = { startDate: null, endDate: null };
  switch (whichEvents) {
    case 'none':
      d.startDate = null;
      d.endDate = null;
      break;
    case 'next':
      d.startDate = moment().startOf('day');
      d.endDate = null;
      break;
    case 'today':
      d.startDate = moment().startOf('day');
      d.endDate = moment().endOf('day');
      break;
    case 'weekend':
      const friday = 5;
      const sunday = 7;
      const now_weekday = moment().isoWeekday();
      const nextFriday =
        now_weekday < friday
          ? moment().add(friday - now_weekday, 'days')
          : moment();
      const nextSunday =
        now_weekday < sunday
          ? moment().add(sunday - now_weekday, 'days')
          : moment();
      d.startDate = nextFriday.startOf('day');
      d.endDate = nextSunday.endOf('day');
      break;
    case 'month':
      d.startDate = moment().startOf('month');
      d.endDate = moment().endOf('month');
      break;
    default:
      break;
  }

  return d;
};

export const getFiltersReducer = (initialFiltersState) => (
  state = initialFiltersState,
  action,
) => {
  let newState = { ...state };

  switch (action.type) {
    case FILTERS_ACTIONS.TEXT:
      newState.text = action.value;
      newState.changedFilters = true;
      break;

    case FILTERS_ACTIONS.SUBJECT:
      newState.subject = action.value;
      newState.changedFilters = true;
      break;
    case FILTERS_ACTIONS.MUNICIPALITY:
      newState.municipality = action.value;
      newState.changedFilters = true;
      break;

    case FILTERS_ACTIONS.DATE:
      newState.date = {
        startDate: action.value.startDate ?? state.startDate,
        endDate: action.value.endDate ?? state.endDate,
      };
      newState.changedFilters = true;
      break;

    case FILTERS_ACTIONS.RESET:
      newState = {
        ...initialFiltersState,
      };

      break;

    default:
      return newState;
  }

  return newState;
};
export const getQueryFilter = (query, i, o) => {
  let ret = null;
  query.forEach((f) => {
    if (i && f.i === i && o && o === f.o) {
      ret = f;
    }
  });
  return ret;
};
export const getFilters = (defaultQuery = [], filterValues) => {
  const date_fmt = 'YYYY-MM-DD HH:mm';
  const { text, subject, date } = filterValues;
  let filters = JSON.parse(JSON.stringify(defaultQuery));

  if (
    !getQueryFilter(
      filters,
      'portal_type',
      'plone.app.querystring.operation.selection.any',
    )
  ) {
    filters.push({
      i: 'portal_type',
      o: 'plone.app.querystring.operation.selection.any',
      v: ['Event'],
    });
  }

  if (text && text.length) {
    filters.push({
      i: 'SearchableText',
      o: 'plone.app.querystring.operation.string.contains',
      v: text + '*',
    });
  }

  if (subject) {
    let defaultSubjectCondition = getQueryFilter(
      filters,
      'Subject',
      'plone.app.querystring.operation.selection.any',
    );

    if (defaultSubjectCondition) {
      defaultSubjectCondition.v = union(defaultSubjectCondition.v, [subject]);
    } else {
      filters.push({
        i: 'Subject',
        o: 'plone.app.querystring.operation.selection.any',
        v: [subject],
      });
    }
  }

  if (date.startDate) {
    filters.push({
      i: 'start',
      o: 'plone.app.querystring.operation.date.largerThan',
      v: date.startDate.startOf('day')?.format(date_fmt),
    });
  }

  if (date.endDate) {
    filters.push({
      i: 'end',
      o: 'plone.app.querystring.operation.date.lessThan',
      v: date.endDate.endOf('day')?.format(date_fmt),
    });
  }

  return filters;
};
